import { render, staticRenderFns } from "./PartsList.vue?vue&type=template&id=25ec9e7c&scoped=true"
import script from "./PartsList.vue?vue&type=script&lang=js"
export * from "./PartsList.vue?vue&type=script&lang=js"
import style0 from "./PartsList.vue?vue&type=style&index=0&id=25ec9e7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ec9e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25ec9e7c')) {
      api.createRecord('25ec9e7c', component.options)
    } else {
      api.reload('25ec9e7c', component.options)
    }
    module.hot.accept("./PartsList.vue?vue&type=template&id=25ec9e7c&scoped=true", function () {
      api.rerender('25ec9e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/PriceParts/PartsList.vue"
export default component.exports